import { List } from 'immutable';
import { directorConstants } from '../constants';
import {
  createFormPassportAdd,
  createFormPassportDelete,
  createFormPassportEdit,
  createFormUtilityBillAdd,
  createFormUtilityBillDelete,
  createFormUtilityBillEdit,
  editFormPassportAdd,
  editFormUtilityBillAdd
} from './helpers';

const DEFAULT_STATE = {
  createForm: {
    passports: [],
    utilityBills: []
  },
  editForm: {
    passports: [],
    utilityBills: []
  }
};

export function directors(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case directorConstants.DIRECTOR_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case directorConstants.DIRECTOR_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case directorConstants.DIRECTOR_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case directorConstants.DIRECTOR_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case directorConstants.DIRECTOR_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case directorConstants.DIRECTOR_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case directorConstants.DIRECTOR_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case directorConstants.DIRECTOR_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const directorIndex = state.items.findIndex(val => val.id == action.response.id);

      if (directorIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(directorIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case directorConstants.DIRECTOR_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case directorConstants.RESET_DIRECTOR_MAIN_RECIPIENT: {
      if (!state.items) {
        return state;
      }

      const directorIndex = state.items.findIndex(val => val.id === action.payload);

      if (directorIndex === -1) {
        return state;
      }
      return {
        ...state,
        items: state.items.set(directorIndex, {
          ...state.items.get(directorIndex),
          mainRecipient: false
        })
      };
    }

    case directorConstants.DIRECTOR_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case directorConstants.DIRECTOR_DELETE_SUCCESS: {
      const { directorId } = action;

      if (!state.items) {
        return state;
      }

      const directorIndex = state.items.findIndex(val => val.id == directorId);

      if (directorIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(directorIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case directorConstants.DIRECTOR_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case directorConstants.DIRECTOR_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    case directorConstants.DIRECTOR_CREATE_FORM_PASSPORT_ADD:
      return createFormPassportAdd(state, action, 'directorId');

    case directorConstants.DIRECTOR_CREATE_FORM_PASSPORT_EDIT:
      return createFormPassportEdit(state, action);

    case directorConstants.DIRECTOR_CREATE_FORM_PASSPORT_DELETE:
      return createFormPassportDelete(state, action);

    case directorConstants.DIRECTOR_CREATE_FORM_UTILITY_BILL_ADD:
      return createFormUtilityBillAdd(state, action, 'directorId');

    case directorConstants.DIRECTOR_CREATE_FORM_UTILITY_BILL_EDIT:
      return createFormUtilityBillEdit(state, action);

    case directorConstants.DIRECTOR_CREATE_FORM_UTILITY_BILL_DELETE:
      return createFormUtilityBillDelete(state, action);

    case directorConstants.DIRECTOR_EDIT_FORM_PASSPORT_ADD:
      return editFormPassportAdd(state, action, 'directorId');

    case directorConstants.DIRECTOR_EDIT_FORM_PASSPORT_EDIT:
      return {
        ...state,
        editForm: {
          ...state.editForm,
          passports: [
            ...state.editForm.passports.filter(p => p.id !== action.payload.id),
            action.payload
          ]
        }
      };

    case directorConstants.DIRECTOR_EDIT_FORM_PASSPORT_DELETE:
      return {
        ...state,
        editForm: {
          ...state.editForm,
          passports: state.editForm.passports.filter(p => p.id !== action.payload)
        }
      };

    case directorConstants.DIRECTOR_EDIT_FORM_RESET_PASSPORTS:
      return {
        ...state,
        editForm: {
          ...state.editForm,
          passports: []
        }
      };

    case directorConstants.DIRECTOR_EDIT_FORM_UTILITY_BILL_ADD:
      return editFormUtilityBillAdd(state, action, 'directorId');

    case directorConstants.DIRECTOR_EDIT_FORM_UTILITY_BILL_EDIT:
      return {
        ...state,
        editForm: {
          ...state.editForm,
          utilityBills: [
            ...state.editForm.utilityBills.filter(p => p.id !== action.payload.id),
            action.payload
          ]
        }
      };

    case directorConstants.DIRECTOR_EDIT_FORM_UTILITY_BILL_DELETE:
      return {
        ...state,
        editForm: {
          ...state.editForm,
          utilityBills: state.editForm.utilityBills.filter(p => p.id !== action.payload)
        }
      };

    case directorConstants.DIRECTOR_EDIT_FORM_RESET_UTILITY_BILLS:
      return {
        ...state,
        editForm: {
          ...state.editForm,
          utilityBills: []
        }
      };

    default:
      return state;
  }
}
